import { QueryClient } from "@tanstack/react-query";

/** UX-15: shell data (workspace, entitlements, wallet, …) stays fresh for 60 s. */
export const SHELL_STALE_MS = 60_000;
/** UX-15: counters (notifications, unread) refresh at most every 30 s. */
export const COUNTER_STALE_MS = 30_000;

/** One cache per app instance: navigating between pages reuses shell data instead of refetching. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: SHELL_STALE_MS, retry: false, refetchOnWindowFocus: false },
    },
  });
}
